<script lang="ts" setup>
  const props = defineProps<{
    label: string;
  }>();
</script>
<template>
  <p class="text-zinc-600 font-medium line-height-[21px]">{{ props.label }}<span class="text-red-500 ml-1">*</span></p>
</template>
